import { SET_CARD_HEIGHT, SET_EMBED_PARAMS } from 'client/constants/actions';
import { setCardHeight, setEmbedParams } from '../../actions';
import initialState from './initial-state';

type Action = ReturnType<typeof setCardHeight | typeof setEmbedParams>;

export default function settingsReducer(state = initialState, action: Action): typeof initialState {
	if (action.type === SET_CARD_HEIGHT) {
		return {
			...state,
			cardHeight: action.payload,
		};
	}

	if (action.type === SET_EMBED_PARAMS) {
		return {
			...state,
			embed: action.payload,
		};
	}

	return state;
}
